import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class AdminDashboardReportDto {
  @Field(type => [String])
  models?: string[]

  @Field(type => [Int])
  values?: number[]

  @Field(type => Int)
  total?: number
}
